import instance from "./api";

export const fetchDrivers = () =>
  instance
    .get("/dashboard/available-drivers")
    .then((r) => r.data?.data ?? []);